module.exports = __webpack_public_path__ + "img/input-paragraph-icon.b518c09d.svg";